import axios from 'axios'

export default {
	methods: {
		sendFingerprintData(fingerprintData) {
			axios
				.post('/api/fingerprint', fingerprintData)
				.then((response) => {
					console.log('Fingerprint data sent successfully:', response.data)
				})
				.catch((error) => {
					console.error('Error sending fingerprint data:', error.response ? error.response.data : error.message)
				})
		},
		collectFingerprint() {
			if (typeof window === 'undefined') {
				return // 在非浏览器环境中（如SSR）不执行
			}
			const result = {}

			// navigator 部分
			result.userAgent = navigator.userAgent
			result.platform = navigator.platform
			result.hardwareConcurrency = navigator.hardwareConcurrency
			result.deviceMemory = navigator.deviceMemory
			result.language = navigator.language
			result.languages = navigator.languages
			result.maxTouchPoints = navigator.maxTouchPoints
			result.vendor = navigator.vendor
			result.productSub = navigator.productSub
			result.doNotTrack = navigator.doNotTrack

			try {
				result.mimeTypes = Array.from(navigator.mimeTypes || []).map((m) => ({
					type: m.type,
					description: m.description,
				}))
			} catch (e) {
				result.mimeTypes = []
			}

			try {
				result.plugins = Array.from(navigator.plugins || []).map((p) => p.name)
			} catch (e) {
				result.plugins = []
			}

			// screen 部分
			result.screen = {
				width: screen.width,
				height: screen.height,
				availWidth: screen.availWidth,
				availHeight: screen.availHeight,
				colorDepth: screen.colorDepth,
				pixelDepth: screen.pixelDepth,
			}

			// timezone
			try {
				result.timezone = Intl.DateTimeFormat().resolvedOptions().timeZone
			} catch (e) {
				result.timezone = ''
			}

			// canvas 指纹
			try {
				const canvas = document.createElement('canvas')
				const ctx = canvas.getContext('2d')
				ctx.textBaseline = 'top'
				ctx.font = '14px Arial'
				ctx.fillText('CreepJS Test', 2, 2)
				result.canvasFingerprint = canvas.toDataURL()
			} catch (e) {
				result.canvasFingerprint = 'Not available'
			}

			// WebGL
			try {
				const canvasGL = document.createElement('canvas')
				const gl = canvasGL.getContext('webgl') || canvasGL.getContext('experimental-webgl')
				if (gl) {
					const debugInfo = gl.getExtension('WEBGL_debug_renderer_info')
					result.webgl = {
						vendor: debugInfo ? gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL) : null,
						renderer: debugInfo ? gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) : null,
						shadingLanguageVersion: gl.getParameter(gl.SHADING_LANGUAGE_VERSION),
						version: gl.getParameter(gl.VERSION),
					}
				} else {
					result.webgl = 'Not supported'
				}
			} catch (e) {
				result.webgl = 'Error'
			}

			// AudioContext Fingerprint
			try {
				const audioCtx = new (window.OfflineAudioContext || window.webkitOfflineAudioContext)(1, 44100, 44100)
				const oscillator = audioCtx.createOscillator()
				oscillator.type = 'triangle'
				oscillator.frequency.value = 10000
				oscillator.connect(audioCtx.destination)
				oscillator.start(0)
				audioCtx.startRendering().then((buffer) => {
					let fingerprint = ''
					for (let i = 0; i < buffer.length; i++) {
						fingerprint += buffer.getChannelData(0)[i].toString()
					}
					result.audioFingerprint = fingerprint.substr(0, 50)
					this.sendFingerprintData(result)
				})
			} catch (e) {
				result.audioFingerprint = 'Not available'
				this.sendFingerprintData(result)
			}
		},
	},
	mounted() {
		// 避免与activated重复上报
		if (!this.$vnode || !this.$vnode.data || !this.$vnode.data.keepAlive) {
			this.collectFingerprint()
		}
	},
	// 在页面激活时自动上报
	activated() {
		this.collectFingerprint()
	},
}
